import { render, staticRenderFns } from "./BeaconListPage.vue?vue&type=template&id=315d56d0&scoped=true&"
import script from "./BeaconListPage.vue?vue&type=script&lang=js&"
export * from "./BeaconListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315d56d0",
  null
  
)

export default component.exports